import packageJson from "../../package.json";

export const ENV = {
    DEV: import.meta.env.DEV,
    ZOHO_ELITHAIR_SSO_URL:
        import.meta.env.VITE_ZOHO_ELITHAIR_SSO_URL || "https://one.zoho.com/p/700227663/app/70704000003655009/sso",
    ZOHO_YESSMILE_SSO_URL:
        import.meta.env.VITE_ZOHO_YESSMILE_SSO_URL || "https://one.zoho.eu/p/20083018239/app/67409000000750001/sso",
    ZOHO_RHINOMEDICA_SSO_URL:
        import.meta.env.VITE_ZOHO_RHINOMEDICA_SSO_URL || "https://one.zoho.eu/p/20101457997/app/169808000000301003/sso",
    AUTH_SVC_URL: import.meta.env.VITE_AUTH_SVC_URL || "https://dev.svc.elithair.tech/api/auth-svc",
    CALL_SVC_URL: import.meta.env.VITE_CALL_SVC_URL || "https://dev.svc.elithair.tech/api/call-svc",
    FIREBASE_VAPID_KEY:
        import.meta.env.VITE_FIREBASE_VAPID_KEY ||
        "BE2rQrNe7gnb3qKTPHVb-xARnWSN69GQDokHkhVOsKtTXrCDXytKYmqY9B5VhEIkJJGSU9VVZ3NXrLegNnoSIAw",
    APP_URL: import.meta.env.VITE_APP_URL || "https://dev.elitphone.elithair.tech",
    INCIDENTS_API_URL:
        import.meta.env.VITE_INCIDENTS_API_URL ||
        `${import.meta.env.VITE_APP_URL || "https://dev.elitphone.elithair.tech"}/api/incidents`,
    CUSTOM_LOGIN_URL: import.meta.env.VITE_CUSTOM_LOGIN_URL || undefined,
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    CLARITY_PROJECT_ID: import.meta.env.VITE_CLARITY_PROJECT_ID,
    RELEASE_VERSION: packageJson.version,
    FIREBASE_CONFIG: getFirebaseConfig(),
    SOCKET_URL: import.meta.env.VITE_SOCKET_URL || "wss://dev.svc.elithair.tech",
    SOCKET_PATH: import.meta.env.VITE_SOCKET_PATH || "/call-svc/socket.io/",

    // Strapi
    STRAPI_URL: import.meta.env.VITE_STRAPI_URL || "https://strapi.elithair.tech",

    ELITAI_SVC_MCP_URL:
        import.meta.env.VITE_ELITAI_SVC_MCP_URL ||
        `${(import.meta.env.VITE_AUTH_SVC_URL || "https://dev.svc.elithair.tech/api/auth-svc").replace(/\/api\/auth-svc\/?$/, "")}/api/elitai-svc/mcp`,

    /** EzanVakti API (Diyanet prayer times, Iftar). In dev uses Vite proxy to avoid CORS. */
    EZANVAKTI_API_URL:
        import.meta.env.VITE_EZANVAKTI_API_URL ||
        (import.meta.env.DEV ? "/ezanvakti-api" : "https://ezanvakti.emushaf.net"),

    PHONE_VALIDATION_STATUS_ENABLED: import.meta.env.VITE_PHONE_VALIDATION_STATUS_ENABLED || false,

    /** Active voice provider: twilio | vonage */
    TELEPHONY_PROVIDER: import.meta.env.VITE_TELEPHONY_PROVIDER as string | undefined,

    COACHING_SUMMARY_DIMENSION_DEFINITION_IDS: {
        daily: import.meta.env.VITE_COACHING_SUMMARY_DAILY_DIMENSION_DEFINITION_ID || "6a22d1cf14699fd5a956569a",
        weekly: import.meta.env.VITE_COACHING_SUMMARY_WEEKLY_DIMENSION_DEFINITION_ID || "6a213b27d372ee59e4fc92cf",
        monthly: import.meta.env.VITE_COACHING_SUMMARY_MONTHLY_DIMENSION_DEFINITION_ID || "6a22d1df14699fd5a95656f9",
    },
};
type FirebaseConfig = {
    apiKey: string;

    authDomain: string;
    projectId: string;

    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
};

function getFirebaseConfig() {
    try {
        return JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG) as FirebaseConfig;
    } catch (error) {
        console.error("Invalid JSON in VITE_FIREBASE_CONFIG:", error);
        return null;
    }
}

export const SALES_SUMMARY_DEFINITION_ID = "68d2c04ae70eca0f5296c32c";
